import React, { useEffect } from "react";
import Wrapper from "../../UI/Wrapper";
import "../Card/Card.css";
import icon1 from "../../../Icons/CardIcon1.png";
import SalesNewIcon from "../../../Icons/salesIcon.png";

const Card = ({heading,value,icon,background,borderRadius}) => {

 

  return (
    <Wrapper className="customCard">
      <div style={{ padding: "1.5rem", backgroundColor:background , borderRadius:borderRadius, height:"9.2rem"}}>
        <img alt="Loading..." className="form-image-MiniDrawer iconImage" src={icon} />
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h5 style={{ paddingTop: "1rem" ,fontSize:"16px",color:"#FFFFFF"}}>{heading}</h5>
          <h2 style={{paddingLeft:"2.7rem",backgroundColor:"transparent",fontSize:"32px"}}>{value}</h2>
        </div>
      </div>
    </Wrapper>
  );
};

export default Card;
